import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import HeroCardReferenceSkeleton from './HeroCardReferenceSkeleton'

const HeroCardReferencePlaceholder = () => {
  return (
    <HeroCardReferenceSkeleton
      titleSection={
        <LoadingBox width={150} maxWidth="100%">
          &nbsp;
        </LoadingBox>
      }
    />
  )
}

export default HeroCardReferencePlaceholder
